import { regexEmail } from 'utils/utils'

export const FORGOT_PASSWORD_VALIDATION = {
    email: {
        required: 'Email wajib diisi',
        format: {
            pattern: regexEmail,
            message: 'Format email tidak sesuai',
        },
    },
    recaptcha_token: { required: 'Invalid Captcha' },
}
